import { render } from "./Observation.vue?vue&type=template&id=aaeedba6"
import script from "./Observation.vue?vue&type=script&lang=js"
export * from "./Observation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__